export default __webpack_public_path__ + "static/media/Forbes-logo.92edd49b.svg";